import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { formatCurrency } from 'utils';
import { Vehicle } from '../../../../../types/vehicle';
import { Button, Divider } from '@material-ui/core';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const OfferInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const YourOfferInfo = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000;
`;

const WithdrawButton = styled.div`
  width: 200px;
  height: 44px;
  color: #fff;
  background: #3994de;
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 6px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  cursor: pointer;
`;

const StyledDivider = styled(Divider)`
  && {
    margin: 24px 0;
  }
`;

export const AlternativeOfferInfoSection = ({ vehicle }: { vehicle: Vehicle }) => {
  const user = useSelector((state: any) => state.user.user);

  if (user.role !== 'buyer') return null;
  const myOffer = vehicle.my_alternative_bid_offer?.amount;

  if (!myOffer) return null;

  return (
    <>
      <StyledDivider />
      <Wrapper>
        <OfferInfoWrapper>
          <YourOfferInfo>{`Your max offer ${formatCurrency(myOffer)}`}</YourOfferInfo>
        </OfferInfoWrapper>
      </Wrapper>
    </>
  );
};
